export const UNIT_MEASURE_GROUP_TTL_ES = 'Unidad de Medida';
export interface IUnitMeasureBase {
  description: string;
  symbol: string;
}
export interface IUnitMeasure extends IUnitMeasureBase {
  id: number;
}
export type IUnitMeasureUpdate = Partial<IUnitMeasureBase>;
